/* eslint-disable react/prop-types */
import { useState } from 'react';
import { Button } from '@material-ui/core';
import P, { shape } from 'prop-types';
import { Box } from './styles';

const BoxDataComponent = ({title, data}) => {
    const [isExpand, setExpand] = useState(false);

    return (
        <>
            <Box>
                <h3>{title}</h3>
                <div className={isExpand ? '' : 'scroll'}>
                    {data?.map((item) => (
                        <ul>
                            <div className="hover-container">
                                <li>{item.value}</li>
                                <span>{item.qtd}</span>
                                <span className="hover-text">{item.value}</span>
                            </div>
                        </ul>
                    ))}
                </div>
                <div>
                    <br/>
                    <Button
                        onClick={() => {setExpand(!isExpand)}}
                        variant="contained"
                        color="primary">
                        Expandir
                    </Button>
                </div>
            </Box>
        </>
    )
}

BoxDataComponent.propTypes = {
    title: P.string,
    data: P.arrayOf(
      shape({
        id: P.number,
        value: P.string,
      })
    ),
};
  
BoxDataComponent.defaultProps = {
    title: '',
    data: null,
};

export default BoxDataComponent;
